import { jsx } from "react/jsx-runtime";
import { Suspense, lazy } from "react";
import { Dialog, Loader } from "@crehana/ui";
const CoursePreview = /*#__PURE__*/ lazy(()=>import("./CoursePreview.js"));
const LazyCoursePreview = (props)=>/*#__PURE__*/ jsx(Suspense, {
        fallback: /*#__PURE__*/ jsx(Dialog, {
            open: true,
            onDismiss: props.onDismiss,
            size: "s",
            isDark: props.isDark,
            hideCloseBtn: true,
            children: /*#__PURE__*/ jsx("div", {
                className: "relative w-full bg-black",
                style: {
                    paddingTop: '56.25%'
                },
                children: /*#__PURE__*/ jsx("div", {
                    className: "absolute inset-0 flex items-center justify-center",
                    children: /*#__PURE__*/ jsx(Loader, {
                        isWhite: true
                    })
                })
            })
        }),
        children: /*#__PURE__*/ jsx(CoursePreview, {
            ...props
        })
    });
const CoursePreview_LazyCoursePreview = LazyCoursePreview;
export default CoursePreview_LazyCoursePreview;
